module.exports = {
	"pagination": {
		"ListCollections": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "CollectionIds"
		},
		"ListFaces": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Faces"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/rekognition-2016-06-27.paginators.json
// module id = 747
// module chunks = 2